var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWorkflowBot = function SvgWorkflowBot(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 11,
    "data-width-16": 15,
    "data-width-20": 17,
    "data-width-24": 20,
    "data-width-28": 24,
    viewBox: "0 0 16.7 16.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.3 1.2H5.367v2.6H11.3zM5.367 0h-1.2v5h3.566v2.733h-5v3.934H0v5h7.5v-5H3.933V8.933h8.8v2.734H9.167v5h7.5v-5h-2.734V7.733h-5V5H12.5V0H5.367M6.3 12.867H1.2v2.6h5.1zm9.167 0h-5.1v2.6h5.1z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWorkflowBot);
export default ForwardRef;